<template>
  <div class="collectList">
    <!-- <video ref="myVideo" src="http://files.bjmuseum.org.cn/activity/c4339ab3-d423-494a-bfeb-2bde7f95e047.mp4" width="100%" style="display:none;"></video> -->
    <!-- <video id="aaa" ref="myVideo" :src="videoUrl" controls width="100%"></video> -->
    <!-- <video ref="myVideo" :src="videoUrl" width="100%" style="display:none;"></video> -->
    <div class="video-box" :class="{hide: !showVideo}">
      <video ref="myVideo" controls :src="videoUrl" width="100%" webkit-playsinline="true" playsinline="true" x-webkit-airplay="allow" x5-video-player-type="h5" x5-video-player-fullscreen="true" preload="auto"></video>

      <a class="icon-close" @click="hideVideo">
        <img src="@/assets/icon-close.svg" alt="">
      </a>
    </div>

    <p style="font-size:12px;line-height:16px;color:#666;margin-bottom:10px;">版权：北京文博学术大讲堂视频版权为北京市文物局所有，视频仅于北京市博物馆大数据平台上播放，请勿二次上传或编辑，转载链接须经我局授权。</p>

    <ul v-infinite-scroll="loadMore" infinite-scroll-disabled="loading" infinite-scroll-distance="10" class="lists">
      <li @click="gotodetail(item.activityId)" v-for="item in activityData" :key="item.activityId" class="collectItem">
        <div class="pic-box">
          <img :src="item.picUrl" alt="" />
          <!-- <img src="@/assets/images/class1.jpg" alt="" /> -->
          <div class="mask">
            <img class="btn-play cen" src="@/assets/images/play.png" alt="" @click.stop="handlePlay(item)">
          </div>
        </div>

        <div class="iteminfo">
          <div class="tit ellipse">{{item.title}}</div>
          <!-- <div class="time">{{item.activityTime}}</div> -->
          <div class="anthor">
            <span>主讲人：</span>
            <span class="jg">{{item.name}}</span>
            <!-- <span>地点：</span>
            <span>{{item.activityPlace}}</span> -->
          </div>
          <div class="cont">
            <span>主题：</span>
            <span style="line-height:16px;">{{item.theme}}</span>
          </div>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
import { Indicator } from 'mint-ui';
import { api } from '../global/api';
export default {
  name: "activityclass",
  data() {
    return {
      activityData: [],
      loading: true,
      size: 3,
      currentPage: 1,
      videoUrl: '',
      videoEle: '',
      showVideo: false
    }
  },
  mounted() {
    // this.getActivity(false);
    this.getForumData()
  },
  methods: {
    handlePlay(item) {
      this.videoUrl = item.url
      this.videoEle = this.$refs.myVideo

      this.showVideo = true
      this.videoEle.play()
      this.videoEle.pause()
      this.$nextTick(() => {
        this.videoEle.play()
      })
    },
    // 退出
    hideVideo() {
      this.showVideo = false
      this.videoEle.pause()
    },
    loadMore() {
      // 多次加载数据
      setTimeout(() => {
        this.currentPage++;
        this.getActivity(true);
      }, 1000);
    },
    gotodetail(id) {
      // this.$router.push({
      //   path: 'studyDetail',
      //   query: {id: id}
      // });
    },
    getActivity(flag) {
      Indicator.open({ text: '加载中...', spinnerType: 'fading-circle' });
      const params = { activityCategory: 2, size: this.size, currentPage: this.currentPage };
      this.$http.get(api.activity, { params: params }).then(response => {
        let { success, data } = response.data;
        if (success === 1) {
          Indicator.close();
          if (flag) {
            // 多次加载数据
            this.activityData = this.activityData.concat(data);
            if (data.length == 0) {
              this.loading = true;
            } else {
              this.loading = false;
            }
          } else {
            // 第一次加载数据
            this.activityData = data;
            this.loading = false;
          }
        } else {
          console.log("接口异常");
        }
      }, response => {
        console.log("请求失败了");
      })
    },
    getForumData(){
      this.$http.get(api.getForumData).then(response => {
         console.log(response.data)
         this.activityData = response.data;
      })
    }
  }
}
</script>

<style lang="scss"  scoped>
.collectList {
  padding: 0rem 0.75rem 2.5rem;
}
.lists {
  margin: 0;
}
.collectItem {
  display: flex;
  flex-direction: column;
  width: 17.25rem;
  height: 12.9rem;
  position: relative;
  padding: 0;
  margin: 0 0 0.5rem;
}
.collectItem img {
  display: block;
  width: 17.25rem;
  height: 12.9rem;
  border-radius: 0.5rem;
}
.pic-box {
  position: relative;
}
.pic-box .mask {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.5);
  border-radius: 0.5rem;
}
.pic-box .cen {
  position: absolute;
  width: 2rem;
  height: 2rem;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  cursor: pointer;
  z-index: 2;
}

.iteminfo {
  // background-color: #666666;
  position: absolute;
  // width: 16.5rem;
  // left: 0.75rem;
  // bottom: 0.5rem;
  width: 16.25rem;
  padding: 0.5rem;
  bottom: 0;
  display: block;
  color: rgba(255, 255, 255, 1);
  font-size: 0.65rem;
  font-family: PingFang-SC-Bold;
  background: -webkit-linear-gradient(rgba(0, 0, 0, 0), rgba(0, 0, 0, 1));
  background: -moz-linear-gradient(
    top,
    rgba(255, 255, 255, 0) 0%,
    rgba(255, 255, 255, 1) 100%
  ); /*FireFox*/
  background: -o-linear-gradient(
    top,
    rgba(255, 255, 255, 0) 0%,
    rgba(255, 255, 255, 1) 100%
  ); /* Opear */
  background: -ms-linear-gradient(
    rgba(0, 0, 0, 0),
    rgba(0, 0, 0, 1)
  ); /*IE10及IE10+*/
  background: linear-gradient(rgba(0, 0, 0, 0), rgba(0, 0, 0, 1));
  // opacity: 0.8;
  .tit {
    color: #ffffff;
    font-weight: bold;
    font-size: 0.7rem;
    height: 0.8rem;
    padding-top: 1px;
  }
  .time {
    margin-top: 0.2rem;
    color: #ffffff;
    font-size: 0.65rem;
  }
  .anthor {
    margin-top: 0.2rem;
    color: #ffffff;
    font-size: 0.65rem;
    .jg {
      margin-right: 0.5rem;
    }
  }
  .cont {
    margin-top: 0.2rem;
    color: #ffffff;
    font-size: 0.65rem;
  }
}

.video-box {
  width: 100%;
  height: 100vh;
  position: fixed;
  overflow: hidden;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 999;
  display: flex;
  align-items: center;
  background-color: #000000;
  &.hide {
    display: none;
  }
  .icon-close {
    position: absolute;
    top: 1rem;
    right: 1rem;
    img {
      width: 1.7rem;
      height: 1.7rem;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/view/activityclass.vue